import {ImageMasonryWall, useFetchEntries} from 'Event/ImageWaterfall'
import {PageDescription, PageTitle} from 'Event/template/Panels/Page'

import FullPageLoader from 'lib/ui/layout/FullPageLoader'
import React from 'react'
import TextContent from 'lib/ui/form/HTMLEditor/HTMLContent'
import {useAttendeeVariables, useGuestVariables} from 'Event'
import {usePanelsTemplate} from 'Event/template/Panels'
import {useToggle} from 'lib/toggle'
import PanelsImageWaterfallConfig from 'Event/template/Panels/ImageWaterfall/ImageWaterfallConfig'
import {Editable} from 'Event/Dashboard/editor/views/EditComponent'
import EditModeOnly from 'Event/Dashboard/editor/views/EditModeOnly'
import Scripts, {IMAGE_WATERFALL} from 'Event/Scripts'
import {useEditMode} from 'Event/EditModeProvider'

export default function PanelsImageWaterfall() {
  const {loading, entries} = useFetchEntries()
  const {imageWaterfall: pageSettings} = usePanelsTemplate()
  const v = useGuestVariables()
  const isEditMode = useEditMode()

  if (loading) {
    return <FullPageLoader />
  }

  if (isEditMode) {
    return <ConfigurablePanelsImageWaterfall />
  }

  return (
    <>
      <Scripts page={IMAGE_WATERFALL} />
      <PageTitle>{v(pageSettings.title)}</PageTitle>
      <PageDescription>
        <TextContent>{v(pageSettings?.description)}</TextContent>
      </PageDescription>
      <ImageMasonryWall entries={entries} />
    </>
  )
}

function ConfigurablePanelsImageWaterfall() {
  const {entries} = useFetchEntries()
  const {imageWaterfall: pageSettings} = usePanelsTemplate()
  const v = useAttendeeVariables()
  const {flag: configVisible, toggle: toggleConfig} = useToggle()

  return (
    <>
      <Scripts page={IMAGE_WATERFALL} />
      <EditModeOnly>
        <PanelsImageWaterfallConfig
          showing={configVisible}
          onClose={toggleConfig}
        />
      </EditModeOnly>
      <Editable onEdit={toggleConfig}>
        <PageTitle>{v(pageSettings.title)}</PageTitle>
      </Editable>
      <PageDescription>
        <TextContent>{v(pageSettings?.description)}</TextContent>
      </PageDescription>
      <ImageMasonryWall entries={entries} />
    </>
  )
}
